import type { IStringifyOptions } from 'qs';
import qs from 'qs';

export const parseUrlParams = (search: string, options: Omit<IStringifyOptions, 'ignoreQueryPrefix'> = {}) =>
  qs.parse(search, { ignoreQueryPrefix: true, ...options });
